import React from 'react';
import Pricing from '../components/Pricing';
import PageHero from '../components/PageHero';
import { useLanguage } from '../contexts/LanguageContext';

const PricingPage: React.FC = () => {
  const { t, language } = useLanguage();

  return (
    <div>
      <PageHero 
        title={t('nav.pricing')} 
        subtitle={language === 'en' 
          ? 'Customized pricing plans tailored to your needs'
          : 'Az Ön igényeire szabott, testreszabott árazási tervek'
        } 
      />
      <Pricing />
    </div>
  );
};

export default PricingPage; 